<template>
    <page :busy="busy">
        <vue-apex-charts type="line" :options="options" :series="series" width="100%" height="400" />
    </page>
</template>

<script>
import { mapGetters } from 'vuex';
import API from '../../../api';
import { STAYLIO_APP_STATISTICS_USER_ENDPOINT } from '../../../endpoints';
import DateRangePicker from '../../generic/date-range-picker/date-range-picker.vue';
import Grid from '../../generic/grid/grid.vue';
import page from '../../generic/page/page.vue';
import FormInput from '../../generic/form-input/form-input.vue';
import SearchMultiselect from '../../generic/search-multiselect/search-multiselect.vue';
import ExportToExcelButton from '../../generic/export-to-excel-button/export-to-excel-button.vue';
import MoreFiltersDropdown from '../../generic/more-filters-dropdown/more-filters-dropdown.vue';
import CardGrid from '../../generic/card-grid/card-grid.vue';
import VueApexCharts from 'vue3-apexcharts';
import Card from '../../generic/card/card.vue';
import ResponsiveDropdown from '../../generic/responsive-dropdown/responsive-dropdown.vue';

export default {
    components: {
        page,
        Grid,
        DateRangePicker,
        FormInput,
        SearchMultiselect,
        ExportToExcelButton,
        MoreFiltersDropdown,
        VueApexCharts,
        Card,
        CardGrid,
        ResponsiveDropdown,
    },
    name: 'StaylioAppDownloads',
    data() {
        return {
            busy: false,
            months: [],
            amount_total: [],
            amount_ios: [],
            amount_android: [],
        };
    },
    computed: {
        ...mapGetters('header', ['userCurrencySymbol']),

        options() {
            return {
                chart: {
                    type: 'line',
                    width: '100%',
                    height: 400,
                    zoom: {
                        enabled: false,
                    },
                },
                stroke: {
                    width: [5, 7, 5],
                    curve: 'straight',
                    dashArray: [0, 8, 5],
                },
                markers: {
                    size: 0,
                    hover: {
                        sizeOffset: 6,
                    },
                },
                xaxis: {
                    categories: this.months,
                },
                tooltip: {
                    y: [
                        {
                            title: {
                                formatter(val) {
                                    return val;
                                },
                            },
                        },
                        {
                            title: {
                                formatter(val) {
                                    return val;
                                },
                            },
                        },
                        {
                            title: {
                                formatter(val) {
                                    return val;
                                },
                            },
                        },
                    ],
                },
            };
        },

        series() {
            const downloads = [
                {
                    name: 'Total Downloads',
                    data: this.amount_total,
                },
                {
                    name: 'iOS Downloads',
                    data: this.amount_ios,
                },
                {
                    name: 'Android Downloads',
                    data: this.amount_android,
                },
            ];
            return downloads;
        },
    },
    mounted() {
        Promise.all([this.getDownloadData()]);
    },
    methods: {
        async getDownloadData() {
            const { data } = await API.get(`${STAYLIO_APP_STATISTICS_USER_ENDPOINT()}download-chart/`);
            this.months = data.months;
            this.amount_total = data.amount_total;
            this.amount_ios = data.amount_ios;
            this.amount_android = data.amount_android;
        },
        async refresh() {
            //
        },
    },
};
</script>

<style lang="scss" scoped>
.subscribers-list-wrapper {
    top: 40px;
}
.subscribers-wrapper {
    min-width: 300px;
}
</style>
